import { View } from './view'

export const ServicePros = View
